<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-row type="flex" class="subject_title">
				<img src="@/assets/img/tag.png" alt="">
				<span class="title_text">企业账号</span>
				<span style="margin-top: 12px;font-size:12px; color:red;margin-left: 10px;">[ 默认密码为 1q2w3e4r ]</span>
			</el-row>
			<!-- 放置表单 -->
			<el-form ref="form" :model="form" label-width="auto" :rules="rules" class="form">
				<!-- 一 -->
				<el-row>
					<!-- <el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="员工账号" prop="username">
							<el-input v-model.trim="form.username" size="large"></el-input>
						</el-form-item>
					</el-col> -->
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="5">
						<el-form-item label="员工姓名" prop="username">
							<el-input v-model.trim="form.username" size="large"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="5">
						<el-form-item label="联系电话" prop="mobile">
							<el-input v-model.trim="form.mobile" size="large" :disabled="disabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="5">
						<el-form-item label="角色" prop="is_super">
							<el-select v-model="form.is_super" placeholder="请选择" style="width:100%">
								<el-option v-for="item in roleList" :key="item.id" :label="item.role_name" :value="item.id"
									:disabled="Boolean(item.disabled)">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 二 -->
				<el-row>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="状态" prop="status">
							<el-radio v-model.number="form.status" :label="10">启用</el-radio>
							<el-radio v-model.number="form.status" :label="20">禁用</el-radio>
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
			<!--  / 放置表单 -->

			<div style="text-align:center; margin-top: 51px;">
				<el-button type="info" @click="$router.back(-1)">返回</el-button>
				<el-button class="change" type="primary" @click="isOk">确定</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import { regular } from '@/utils/validate'
import { getAllRoles, getUserItem, saveUserItem, addUserItem } from '@/api/manage.js'

export default {
	name: 'AddAccountManagementVue',
	data() {
		return {
			title: '新增账号',
			breadcrumbList: [
				{ name: "账号管理", path: "account_management" },
				{ name: "新增", path: "account_management/add_account_management" },
			],
			id: '',
			form: {
				status: 10,// 10 启用 20 禁用
			},
			roleList: [],//角色组
			rules: {
				username: [
					{ required: true, message: '请输入员工姓名', trigger: 'blur' },
				],
				mobile: [
					{ required: true, message: '请输入员工联系电话', trigger: 'blur' },
					{
						pattern: regular.phone,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				],
				status: [
					{ required: true, message: '请选择状态', trigger: 'change' },
				],
				is_super: [
					{ required: true, message: '请选择角色', trigger: 'blur' },
				],
			},
			disabled: false,
			cache: 0
		}
	},
	created() {
		this.info()
	},
	methods: {
		async info() {
			this.roleList = await getAllRoles()
			const id = this.$route.query.id
			if (id) {
				this.id = this.$route.query.id
				this.breadcrumbList[1].name = '修改'
				this.title = '修改账号'
				this.disabled = true

				// 回填
				const res = await getUserItem(id)
				this.form = res
			}
		},
		isOk() {// 确定提交表单
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					// 点击确认 
					this.cache = 1
					this.loading = true

					if (this.id) {
						await saveUserItem({
							id: this.id,
							// username: this.form.username,
							username: this.form.username,
							mobile: this.form.mobile,
							status: this.form.status,
							is_super: this.form.is_super,
						})
						this.$message({
							showClose: true,
							message: '修改成功',
							type: 'success'
						})
					} else {
						await addUserItem({
							// username: this.form.username,
							username: this.form.username,
							mobile: this.form.mobile,
							status: this.form.status,
							is_super: this.form.is_super,
						})
						this.$message({
							showClose: true,
							message: '新增成功',
							type: 'success'
						})
					}

					this.$router.push('/account_management')
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}
	},
	watch: {
		cache(val) {
			// 点击确认,清除缓存
			if (val === 1) {
				this.$store.commit('setKeep', '')
			}
		}
	},
}
</script>

<style lang="less" scoped>
.subject_title {
	margin-bottom: 23px;

	img {
		width: 30px;
		height: 39px;
		margin-right: 3px;
	}

	.title_text {
		font-size: 18px;
		line-height: 36px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #6345D5;
	}
}
</style>>